import { ApiResponse, LoginCredentials, RegisterCredentials } from "../../types/admin";
import httpClient from "../httpClient";

export const authApi = {
  login: (credentials: LoginCredentials): Promise<ApiResponse<{ token: string }>> =>
    httpClient.postPublic("/auth/login", credentials),

  register: (credentials: RegisterCredentials): Promise<ApiResponse<void>> =>
    httpClient.postPublic("/auth/register", credentials),

  canRegister: (): Promise<ApiResponse<{ allowed: boolean }>> =>
    httpClient.get("/auth/can-register"),

  validate: (): Promise<ApiResponse<{ valid: boolean }>> =>
    httpClient.get("/auth/validate"),
};
